import React from 'react';
import PropTypes from 'prop-types';

import FormattedText from '../../../01_atoms/FormattedText';
import ActivismBlockInfo from '../../../02_molecules/ActivismBlockInfo';
import QuotationMark from '../../../../public/static/icons/quotation-mark.svg';
import DefaultPicture, { propTypes as picturePropTypes } from '../../../01_atoms/DefaultPicture';
import {
  generateClassNameByBehaviorSettings,
  behaviorSettingsProps,
} from '../../../../utils/behaviorSettings';
import { propTypes as socialMediaEmbedFeedPropTypes } from '../BBSocialMediaFeedEmbed';
import TiktokSociablekit from '../../../02_molecules/TiktokSociablekit';

import styles from './index.module.scss';

const BBActivismQuote = ({
  heading = '',
  subheading = '',
  title = '',
  image,
  quote,
  authorName = '',
  authorPosition = '',
  additionalTextHl = '',
  additionalText = '',
  widget = null,
  behaviorSettings = null,
  uuid = null,
}) => (
  <div
    className={`bb ${styles['bb-activism-quote']} ${generateClassNameByBehaviorSettings(
      behaviorSettings,
    )}`}
    id={uuid}
  >
    <ActivismBlockInfo title={heading} subtitle={subheading} size="large" />

    <div className="container">
      <div className={styles['bb-activism-quote__content-wrapper']}>
        {title && <h2 className={styles['bb-activism-quote__title']}>{title}</h2>}

        <div className={styles['bb-activism-quote__quote-group']}>
          <div className={styles['bb-activism-quote__image']}>
            <DefaultPicture {...image} />
          </div>

          <div className={styles['bb-activism-quote__quote-wrapper']}>
            <div className={styles['bb-activism-quote__quote-content']}>
              <QuotationMark className={styles['bb-activism-quote__mark']} />

              <FormattedText className={styles['bb-activism-quote__quote']} text={quote} />

              {(authorName || authorPosition) && (
                <div className={styles['bb-activism-quote__name-group']}>
                  {authorName && authorName}
                  {authorName && authorPosition ? ' - ' : ''}
                  {authorPosition && authorPosition}
                </div>
              )}
            </div>
          </div>
        </div>

        {(additionalTextHl || additionalText) && (
          <div className={styles['bb-activism-quote__additional-content']}>
            {additionalTextHl && (
              <FormattedText
                className={styles['bb-activism-quote__text-hl']}
                text={additionalTextHl}
              />
            )}
            {additionalText && (
              <FormattedText className={styles['bb-activism-quote__text']} text={additionalText} />
            )}
          </div>
        )}

        {widget && widget.widgetProps && (
          <div className={styles['bb-activism-quote__sm-feed']}>
            {widget.provider === 'tiktok-sociablekit' && (
              <TiktokSociablekit {...widget.widgetProps} />
            )}
          </div>
        )}
      </div>
    </div>
  </div>
);

BBActivismQuote.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.shape(picturePropTypes).isRequired,
  quote: PropTypes.string.isRequired,
  authorName: PropTypes.string,
  authorPosition: PropTypes.string,
  additionalTextHl: PropTypes.string,
  additionalText: PropTypes.string,
  widget: PropTypes.shape(socialMediaEmbedFeedPropTypes),
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBActivismQuote;
